import React from "react";
import "./button.css";

/**
 * This component is used on Brand Page, Apply For Brand Page
 */
function Button(props) {
  const { value, handleClick, icon = null } = props;
  return (
    <button onClick={handleClick} className="btn-container">
      {value}
      {icon ? icon : null}
    </button>
  );
}

export default Button;
